/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Models an OpenAPI 3.0.x Discriminator.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export class Oas30Discriminator extends ExtensibleNode {
    public propertyName : string;

    public mapping : any;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitDiscriminator(this);
    }

    /**
     * Gets a mapping value by its key.
     * @param {string} key
     * @return {string}
     */
    public getMapping(key : string) : string {
        if(this.mapping == null) {
            return null;
        }
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.mapping, key);
    }

    /**
     * Adds a mapping.
     * @param {string} key
     * @param {string} value
     */
    public addMapping(key : string, value : string) {
        if(this.mapping == null) {
            this.mapping = <any>({});
        }
        /* put */(this.mapping[key] = value);
    }

    constructor() {
        super();
        if(this.propertyName===undefined) this.propertyName = null;
        if(this.mapping===undefined) this.mapping = null;
    }
}
Oas30Discriminator["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Discriminator";
Oas30Discriminator["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




